import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React from "react";
import './InfoDialog.css';

export default class InfoDialog extends React.Component<any, any> {
    render() {
        return (
            this.props.show ?
            <Dialog
                    id={"info-dialog"}
                    open={this.props.show}
                    onClose={this.props.onClose}
                    aria-labelledby="info-dialog-title"
                    aria-describedby="info-dialog-description"
                >
                    <DialogTitle id="info-dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="info-dialog-description">
                            {this.props.content}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions id={"info-dialog-actions-container"}>
                        <Button id={"info-dialog-button"} onClick={this.props.onClose}>
                            {this.props.buttonText.toUpperCase()}
                        </Button>
                    </DialogActions>
                </Dialog> : null
        )
    }
}